<template>
	<div>
		<div class="title-with-right-button-area" :ref="'detailTop'">
			<h2>사업비관리 상세</h2>
		</div>

		<section class="mybusiness-area">
			<div class="round-container business-card">
				<div class="card-design"></div>
				<div class="title">
					선금
				</div>
				<div class="status">
					<p v-if="programFirstFeeState === 'REFUND'" class="color-red">환불</p>
					<p v-else-if="programFirstFeeState === 'NOT_PAY'" class="color-shineGray">지급없음</p>
					<p v-else-if="programFirstFeeState === 'APPROVING'" class="color-yellow">승인중</p>
					<p v-else-if="programFirstFeeState === 'COMPLATE'" class="color-blue">지급완료</p>
					<p v-else class="color-shineGray">지급대기</p>
					<p class="fee">{{ programFirstFee }}원</p>
				</div>
			</div>
			<div class="round-container business-card">
				<div class="card-design"></div>
				<div class="title">
					잔금
				</div>
				<div class="status">
					<p v-if="programEndFeeState === 'REFUND'" class="color-red">환불</p>
					<p v-else-if="programEndFeeState === 'NOT_PAY'" class="color-shineGray">지급없음</p>
					<p v-else-if="programEndFeeState === 'APPROVING'" class="color-yellow">승인중</p>
					<p v-else-if="programEndFeeState === 'COMPLATE'" class="color-blue">지급완료</p>
					<p v-else class="color-shineGray">지급대기</p>
					<p class="fee">{{ programEndFee }}원</p>
				</div>
			</div>
		</section>

		<section class="round-container">
			<div class="mybusiness-company-info">
				<div class="block">
					<nav-link class="company-link" :url="'/mybusiness/detail/' + matchSeqNo">
						<div class="title">
							<span>{{ companyNmKor + ' - ' + programNm }}</span>
							<span class="company-tp"><font-awesome-icon class="arrow" icon="chevron-right"/></span>
						</div>
					</nav-link>
				</div>
				<div class="block half">
					<div class="col-header">연도</div>
					<div class="col-contents">{{ businessYear }}</div>
				</div>
				<div class="block half">
					<div class="col-header">사업자등록번호</div>
					<div class="col-contents">{{ registrationNo }}</div>
				</div>
				<div class="block half">
					<div class="col-header">협약기간</div>
					<div class="col-contents">
						{{ agreementDate }}
					</div>
				</div>
				<div class="block half mobile-hide"></div>
			</div>
		</section>

		<div style="margin-bottom: 20px">
			<h2 class="mt30">관리자메모</h2>
			<section class="round-container">
				<div class="mybusiness-admin-memo">
					{{ this.apiData.adminMemo }}
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import CONST from '@/constants';
import moment from 'moment-timezone';

export default {
	title: '내비즈니스상세',
	name: 'MyBusinessDetail',
	components: {},
	props: ['seqNo'],
	data: function() {
		return {
			loginMember: null,
			eventBus,
			CONST,
			select: 1,
			apiData: [],
			userSeqNo: 0,
			matchSeqNo: 0,
			companySeqNo: 0,
			registrationNo: '',
			agreementDate: '협약기간 없습니다.',
			companyNmKor: '기업명',
			programNm: '프로그램명',
			businessYear: '사업연도',

			programFirstFeeState: 'EXPAND',
			programEndFeeState: 'EXPAND',

			programFirstFee: '1,000,000',
			programEndFee: '1,000,000',
		};
	},
	created() {
		// eventBus.$on('LOAD_POPUP_AGREEMENT_DATA', () => {
		// 	this.getBusinessDetail(() => {
		// 		this.openAgreement();
		// 	});
		// });
		// eventBus.$on('LOAD_POPUP_VISIT_DATA', () => {
		// 	this.getBusinessDetail(() => {
		// 		this.openVisit();
		// 	});
		// });
	},
	mounted() {
		eventBus.$emit(CONST.EVENTS.SET_SIDE_MENU, 'FEE');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		this.getBusinessDetail();
		// this.getServiceCodeList();
		// eventBus.$on(
		// 	CONST.EVENTS.SAVE_REPORT_COMMENT,
		// 	function() {
		// 		this.doCompanyMemoSave();
		// 	}.bind(this),
		// );
	},
	beforeDestroy() {
		// eventBus.$off(CONST.EVENTS.SAVE_REPORT_COMMENT);
	},
	computed: {},
	methods: {
		openAgreement: function() {
			// if (this.isCompany && this.apiData.approveFCd === 'REFUND') {
			// 	alert('환불된 사업입니다.');
			// 	return false;
			// }
			// if (this.isCompany && this.apiData.approveFCd !== 'APPROVE') {
			// 	alert('승인되지 않은 사업입니다.');
			// 	return false;
			// }
			// //TODO 임시헤제
			// if (this.mtSubmitState !== 'DONE' && this.mtSubmitState !== 'CONFIRM' && this.isCompany) {
			// 	alert('마케터가 협약서를 작성중입니다.');
			// 	return false;
			// }
			//
			// let param = {
			// 	matchSeqNo: this.apiData.seqNo,
			// 	mtSeqNo: this.apiData.mtSeqNo,
			// 	companySeqNo: this.apiData.companySeqNo,
			// 	mtSubmitState: this.mtSubmitState,
			// 	companySubmitState: this.companySubmitState,
			// 	nonAgreeReason: this.nonAgreeReason,
			// 	nonAgreeTarget: this.nonAgreeTarget,
			// 	reportType: CONST.REPORT_TYPE.AGREE_REPORT,
			// 	specialContract: this.apiData.specialContract,
			// };
			//
			// let userGrdCode = this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY ? CONST.USER_TYPE.COMPANY : CONST.USER_TYPE.MARKETER;
			//
			// if (
			// 	!(param.companySubmitState === 'DONE' && param.mtSubmitState === 'CONFIRM') &&
			// 	param.nonAgreeReason !== null &&
			// 	param.nonAgreeTarget === userGrdCode
			// ) {
			// 	eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'agreeNoticeModal', '미동의사유', param);
			// } else {
			// 	eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'modalAgree', '협약관리', param);
			// }
		},
		getBusinessDetail: function() {
			this.apiData = [];
			let formData = new FormData();
			formData.append('seqNo', this.seqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getBusinessFeeDetail.do', formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
						this.$device.pushView('/mybusinessfee');
					} else {
						if (res.data.data != null) {
							this.apiData = res.data.data;
							this.companySeqNo = this.apiData.companySeqNo;
							this.userSeqNo = this.apiData.userSeqNo;
							this.matchSeqNo = this.apiData.matchSeqNo;

							this.companyNmKor = this.apiData.companyNmKor;
							this.programNm = this.apiData.programNm;
							this.businessYear = this.apiData.businessYear;

							this.registrationNo = this.$options.filters['registrationNoOnly'](this.apiData.registrationNo);
							if (this.apiData.agreementStartDate && this.apiData.agreementEndDate) {
								this.agreementDate =
									this.$moment(moment(this.apiData.agreementStartDate).tz('Asia/Seoul')).format('YYYY.MM.DD') +
									' ~ ' +
									this.$moment(moment(this.apiData.agreementEndDate).tz('Asia/Seoul')).format('YYYY.MM.DD');
							}

							this.programFirstFeeState = this.apiData.programFirstFeeState;
							this.programEndFeeState = this.apiData.programEndFeeState;

							this.programFirstFee = this.apiData.programFirstFee.format();
							this.programEndFee = this.apiData.programEndFee.format();
						}
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
	},
};
</script>

<style scoped></style>
